export const MODAL_RESERVA_CLOSE_REASON = Object.freeze({
  SAVED: 'SAVED',
  ERROR: 'ERROR',
  CLOSE: 'CLOSE'
})

export const MODAL_RESERVA_STEPS = Object.freeze({
  CLIENTE: 'CLIENTE',
  PERITAJE: 'PERITAJE',
  COLORES: 'COLORES',
  SUCURSALES: 'SUCURSALES',
  PAGOS: 'PAGOS',
  COMPLETED: 'COMPLETED'
})
